import React, { useState } from 'react';
import SideMenu from '../components/Sidebar/SideMenu';
import { GiHamburgerMenu } from "react-icons/gi";
const MainLayout = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSideMenu = () => {
    setIsOpen(prev => !prev);
  }

  return (

    <div className='bg-primary flex'>
      <SideMenu
        isOpen={isOpen}
        setIsOpen={setIsOpen}

      />
      <main className="flex-grow h-screen overflow-auto scrollbar-hide relative ">
        <div className="md:hidden">
          <div className='w-[30px] h-[30px] text-secondary text-2xl absolute right-2 top-7 z-[99999]'>
            <button onClick={handleSideMenu}>
              <GiHamburgerMenu />
            </button>
          </div>
          {isOpen && (
            <div
              className="fixed inset-0 z-30 bg-[#111] bg-opacity-75 md:hidden"
              onClick={handleSideMenu}
            />
          )}
        </div>
        {children}
      </main>
    </div>
  );
};

export default MainLayout;
